const BranchIcon = ({ size = 16, color = '#212529' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2168 7.32132V8.68569C10.2168 9.72193 11.0566 10.5617 12.0928 10.5617H13.4572C14.4934 10.5617 15.3332 9.72193 15.3332 8.68569V7.32132C15.3332 6.28508 14.4934 5.44531 13.4572 5.44531H12.0928C11.0566 5.44531 10.2168 6.28508 10.2168 7.32132ZM11.2401 7.32132C11.2401 6.85061 11.6221 6.46859 12.0928 6.46859H13.4572C13.9279 6.46859 14.3099 6.85061 14.3099 7.32132V8.68569C14.3099 9.15639 13.9279 9.53842 13.4572 9.53842H12.0928C11.6221 9.53842 11.2401 9.15639 11.2401 8.68569V7.32132Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.666992 2.54007V3.90444C0.666992 4.94068 1.50676 5.78044 2.543 5.78044H3.90737C4.9436 5.78044 5.78337 4.94068 5.78337 3.90444V2.54007C5.78337 1.50383 4.9436 0.664062 3.90737 0.664062H2.543C1.50676 0.664062 0.666992 1.50383 0.666992 2.54007ZM1.69027 2.54007C1.69027 2.06936 2.07229 1.68734 2.543 1.68734H3.90737C4.37807 1.68734 4.7601 2.06936 4.7601 2.54007V3.90444C4.7601 4.37514 4.37807 4.75717 3.90737 4.75717H2.543C2.07229 4.75717 1.69027 4.37514 1.69027 3.90444V2.54007Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.666992 12.0948V13.4591C0.666992 14.4954 1.50676 15.3351 2.543 15.3351H3.90737C4.9436 15.3351 5.78337 14.4954 5.78337 13.4591V12.0948C5.78337 11.0585 4.9436 10.2188 3.90737 10.2188H2.543C1.50676 10.2188 0.666992 11.0585 0.666992 12.0948ZM1.69027 12.0948C1.69027 11.624 2.07229 11.242 2.543 11.242H3.90737C4.37807 11.242 4.7601 11.624 4.7601 12.0948V13.4591C4.7601 13.9298 4.37807 14.3119 3.90737 14.3119H2.543C2.07229 14.3119 1.69027 13.9298 1.69027 13.4591V12.0948Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.19792 11.2435L3.22453 11.2442L3.24636 11.2415C3.34459 11.2278 3.73617 11.1446 3.73617 10.7237V10.0504C3.73617 9.64311 3.89784 9.2529 4.18573 8.96502C4.47361 8.67714 4.86382 8.51546 5.27108 8.51546H10.7286C11.011 8.51546 11.2402 8.28625 11.2402 8.00383C11.2402 7.7214 11.011 7.49219 10.7286 7.49219H5.27108C4.59231 7.49219 3.94219 7.76165 3.46193 8.24123C2.98235 8.72148 2.71289 9.3716 2.71289 10.0504V10.7237V10.7278V10.7326C2.71289 10.768 2.7163 10.8028 2.72381 10.8363C2.73745 10.9092 2.76474 10.9693 2.80021 11.0184C2.88753 11.148 3.03284 11.2353 3.19792 11.2435Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7498 6.46227L12.7764 6.46295L12.7982 6.46022C12.8965 6.44658 13.288 6.36335 13.288 5.94244C13.288 5.89196 13.288 5.62182 13.288 5.26913C13.288 4.59035 13.0186 3.94023 12.539 3.45998C12.0587 2.9804 11.4086 2.71094 10.7299 2.71094H5.27238C4.98996 2.71094 4.76074 2.94015 4.76074 3.22258C4.76074 3.505 4.98996 3.73421 5.27238 3.73421H10.7299C11.1371 3.73421 11.5273 3.89589 11.8152 4.18377C12.1031 4.47165 12.2648 4.86186 12.2648 5.26913V5.94244V5.94654V5.95131C12.2648 5.98679 12.2682 6.02158 12.2757 6.055C12.2893 6.128 12.3166 6.18803 12.3521 6.23715C12.4394 6.36676 12.5847 6.45408 12.7498 6.46227Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.27238 13.2859H10.0477C10.2544 13.2859 10.4413 13.1611 10.5204 12.9701C10.5996 12.779 10.5559 12.5587 10.4092 12.4127L9.04486 11.0483C8.84566 10.8485 8.52094 10.8485 8.32174 11.0483C8.12186 11.2475 8.12186 11.5723 8.32174 11.7715L8.81223 12.2626H5.27238C4.98996 12.2626 4.76074 12.4918 4.76074 12.7743C4.76074 13.0567 4.98996 13.2859 5.27238 13.2859Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.68518 12.4155L8.32081 13.7799C8.12093 13.9791 8.12093 14.3038 8.32081 14.503C8.52001 14.7029 8.84473 14.7029 9.04392 14.503L10.4083 13.1387C10.6082 12.9395 10.6082 12.6147 10.4083 12.4155C10.2091 12.2157 9.88437 12.2157 9.68518 12.4155Z"
      fill={color}
    />
  </svg>
);

export default BranchIcon;
